export default "__VITE_ASSET__BLamttJk__"